// extracted by mini-css-extract-plugin
export default {"root":"HelpHeader-root__B8SbE","main":"HelpHeader-main__nvR5t"};